<template>
  <div class="home">
    <h1 class="teal--text text--darken-4">Albums photos</h1>
    <br/>
    En construction
  </div>
</template>

<script>
export default {
  name: 'Photos',
  components: {
  },
}
</script>
